import React from "react";
import { Progress, type ProgressProps } from "semantic-ui-react";

type Speed = "slowest" | "slower" | "slow" | "normal" | "fast" | "faster" | "fastest";

interface Props extends ProgressProps {
  isDone: boolean
  onFinish: () => void
  speed?: Speed
}

const speedMap: { [key in Speed]: number } = {
  slowest: 300,
  slower: 200,
  slow: 100,
  normal: 60,
  fast: 40,
  faster: 20,
  fastest: 10
};

// This fake progress bar starts off fast and then gradually slows down
// But if it's finished, it speeds up again
const FakeProgress = (props: Props) => {
  const { _, isDone, onFinish, ...rest } = props;
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prevProgress => {
        const speed = props.speed ?? "normal";
        const incrementFactor = speedMap[speed];
        const progressLeft = 100 - prevProgress;
        const progressIncrement = isDone ? Math.max(progressLeft / 10, 0.5) : progressLeft / incrementFactor;
        const nextProgress = Math.min(prevProgress + progressIncrement, 100);

        // If it's not done, stay at 99%
        const progress = (nextProgress === 100) && !isDone ? 99 : nextProgress;

        if (progress >= 100) {
          clearInterval(interval);
          setTimeout(onFinish, 50);
        }

        return progress;
      });
    }, 30);

    return () => { clearInterval(interval); };
  }, [props.isDone]);

  return <Progress
    color="green"
    progress="percent"
    inverted
    active
    {...rest}
    percent={Math.round(progress)}
  />;
};

export default FakeProgress;